"use client";
import Link from "next/link";
import Logo from "../Logo";
import Image from "next/image";
import { useContext, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { locationcontext } from "@/lib/context";
import { getSEO } from "@/lib/seoHelper";
import placeholder from "@/components/Event/assests/placeholder.png";

const HomePageLogoLink = ({ logo }) => {
  const [imgError, setImgError] = useState(false);
  const { location } = useContext(locationcontext);
  const pathname = usePathname();
  const router = useRouter();

  const handleClick = (e) => {
    if (pathname === "/") {
      e.preventDefault();
      router.refresh();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Link
      href={"/"}
      title={getSEO("common").links?.homeTitle}
      id="site-logo-link"
      prefetch={false}
      onClick={handleClick}
    >
      <Image
        src={imgError || !logo?.url ? placeholder : logo.url}
        onError={() => setImgError(true)}
        alt={logo?.alt_name || logo?.title || "tykkit"}
        width={100}
        height={40}
        className="logo object-contain"
        priority
      />
    </Link>
  );
};

export default HomePageLogoLink;
